import {BeerCreateDto, BeerUpdateDto} from "../../../api";
import BeerModalForm from "../beerModalForm/beerModalForm";

export default function BeerModalFormAddContainer(props: BeerModalFormAddContainerProps) {
    return <BeerModalForm
        isModalVisible={props.addFormVisibility}
        setModalVisibility={props.onFinish}
        onSubmit={props.onSubmit}
        modalTitle={props.title}
        saveButtonTitle="Zapisz"
        cancelButtonTitle={"Anuluj"}
        initialValues={props.BeerToEdit!}
    />;
}

interface BeerModalFormAddContainerProps {
    onFinish: (refreshList: boolean) => void,
    onSubmit: (values: BeerCreateDto | BeerUpdateDto) => Promise<any>,
    addFormVisibility: boolean,
    title: string,
    BeerToEdit: BeerUpdateDto | null
}
